
import { mapState, mapActions, mapGetters } from "vuex";
import NoDataLabel from "../common/no-data-label.vue";
import invoiceTransactionHistoryDialog from "../dialogs/invoice-transaction-history-dialog.vue";
export default {
  components: { invoiceTransactionHistoryDialog, NoDataLabel },
  data() {
    return {
      dialog: false,
      transactionLoading: false
    };
  },
  beforeMount() {
    this.initData();
  },
  computed: {
    ...mapState("payment", ["invoices", "transactions"]),

    transactionHistory() {
      let arr = [];
      this.invoices.forEach((item) =>
        !arr.includes(item.brand) ? arr.push(item.brand) : null
      );
      return arr;
    }
  },
  methods: {
    ...mapActions("payment", ["getTransactions"]),
    initData() {
      this.transactionLoading = true;
      try {
        this.getTransactions();
      } catch (error) {
        this.$nuxt.$emit("show-error-toast", err);
      }
      this.transactionLoading = false;
    },
    toggleTransactionHistoryPopup(visibility) {
      this.dialog = visibility;
    }
  }
};
